"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var MuiTypography = {
  styleOverrides: {
    root: {
      '&.MuiTypography-root': {
        fontFamily: 'cerapro'
      }
    }
  }
};
exports.default = {
  MuiTypography: MuiTypography
};